import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { toVector3 } from '@/utils/math';
import { settings } from '@/config';
import type { TickState } from '@/types';

/**
 * OrbitControls for free inspection (debug only, disabled by default). When
 * enabled it takes over the camera directly, so the CameraController and scroll
 * test are paused by the orchestrator to avoid fighting over the transform.
 */
export class OrbitControlsManager {
  readonly controls: OrbitControls;

  constructor(camera: THREE.Camera, domElement: HTMLElement) {
    this.controls = new OrbitControls(camera, domElement);
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.08;
    this.controls.target.copy(toVector3(settings.camera.start.target));
    this.controls.enabled = false;
  }

  get enabled(): boolean {
    return this.controls.enabled;
  }

  set enabled(value: boolean) {
    this.controls.enabled = value;
  }

  update(_tick: TickState): void {
    if (this.controls.enabled) this.controls.update();
  }

  dispose(): void {
    this.controls.dispose();
  }
}
